import styles from "../RegistrationPage.module.scss";
import classNames from "classnames";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "./ErrorMessage";
import { NavLink, useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import clsx from "clsx";
interface RegFormProps {
  label?: string;
  onValidSubmit: (name: string, agreement: boolean) => void;
  onChange?: (checked: boolean) => void;
  serverError: string | null;
}

const schema = yup.object({
  name: yup
    .string()
    .trim()
    .required("Имя обязательно")
    .max(20, "Имя должно быть не более 20 символов")
    .min(2, "Имя должно быть не менее 2 символов")
    .test(
      "no-special-chars",
      "Имя не должно содержать специальных символов или цифр, кроме пробела и дефиса",
      (value) => {
        return /^[A-Za-zА-Яа-яЁё\s-]+$/.test(value); // Проверка на отсутствие цифр и других символов
      }
    ),
  // agreement: yup.boolean().required().isTrue("Необходимо согласие"),
  agreement: yup
    .boolean()
    .required()
    .isTrue("Необходимо согласие, чтобы продолжить"),
});
type FormValues = yup.InferType<typeof schema>;

export const RegForm: React.FC<RegFormProps> = ({
  onValidSubmit,
  serverError,
  onChange,
}) => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({ resolver: yupResolver(schema) });
  const { onChange: registerOnChange, ...restAgreementProps } =
    register("agreement");

  const [isLoading, setIsLoading] = useState(false);
  // const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const onSubmit = async (data: FormValues) => {
    setIsLoading(true);
    // setErrorMessage(null);
    try {
      onValidSubmit(data.name, data.agreement);
      // } catch (error: any) {
      //   setErrorMessage(error.message || "Ошибка регистрации");
    } finally {
      setIsLoading(false);
    }
  };

  console.log(errors);
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setIsChecked(checked);
    registerOnChange(e);
  };

  return (
    <>
      <form
        style={{ marginBottom: "280px" }}
        className={classNames(styles.form, styles.formgap_1, styles.regForm)}
        onSubmit={handleSubmit(onSubmit)}
      >
        <h2 className={styles.form_title}>Зарегистрируйтесь</h2>
        <div className={styles.contentWrap}>
          <div className={styles.form_inputWrapp}>
            <label htmlFor="userName" className={styles.form_nameLabel}>
              Имя
            </label>
            <input
              id="userName"
              className={classNames(styles.input, styles.nameInput)}
              type="text"
              {...register("name")}
              // placeholder="имя пользователя"
              aria-invalid={errors.name ? "true" : "false"}
            />
            <ErrorMessage message={errors.name?.message} />
            <p className={styles.serverError}>{serverError}</p>
          </div>
          <div className={styles.personData}>
            <label className={styles.checkboxContainer}>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
                className={styles.hiddenCheckbox}
                {...restAgreementProps}
              />

              <span
                className={clsx(styles.customCheckbox, {
                  [styles.checked]: isChecked,
                })}
              >
                {isChecked && (
                  <svg
                    className={styles.checkmark}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="grey"
                    strokeWidth="2"
                  >
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                )}
              </span>
              {/* <span className={styles.checkboxLabel}>{label}</span> */}
            </label>
            {/* <input
              className={styles.personData_check}
              type="checkbox"
              {...register("agreement")}
            /> */}
            <p className={styles.personData_consent}>
              Согласен с
              <NavLink
                to="/information/offer"
                className={styles.personData_ref}
                onClick={() => navigate(`/information/offer`)}
              >
                &nbsp;
                <span className={styles.personDataAgreement}>
                  Пользовательским соглашением
                </span>
              </NavLink>
            </p>
          </div>
          <ErrorMessage message={errors.agreement?.message} />
        </div>

        <button className={styles.form_submitBtn} disabled={isLoading}>
          Войти
        </button>
      </form>
    </>
  );
};
